// extracted by mini-css-extract-plugin
export default {"root":"TermsOfService_root__cIhfc","lastUpdated":"TermsOfService_lastUpdated__4kTl4 marketplaceBodyFontStyles","scopedList":"TermsOfService_scopedList__ubo2D"};